import { apiClient } from "./ApiConfig";

export interface FeedbackOut {
  feedback_id: number;
  consumer_name: string | null;
  avatar_url: string | null;
  rating: number;
  comment: string | null;
  created_at: string | null;
  images: string[];
}

export interface FeedbackPage {
  items: FeedbackOut[];
  total: number;
  page: number;
  page_size: number;
}

export interface RatingDetail {
  quality: number;
  shipping_cost: number;
  shipping_time: number;
  service: number;
}

export interface RatingSummary {
  avg_rating: number;
  total: number;
  by_star: Record<number, number>;
  detail: RatingDetail;
}

export interface FeedbackQuery {
  page?: number;
  page_size?: number;
  star?: number;
}

export interface FeedbackCreate {
  product_id: number;
  rating: number;
  comment: string;
}

export interface FeedbackCreated {
  feedback_id: number;
  product_id: number;
  consumer_id: number;
  rating: number;
  comment: string;
  created_at: string | null;
}

export const buildFeedbackQuery = (params?: FeedbackQuery): string => {
  if (!params) {
    return "";
  }
  const query = new URLSearchParams();
  if (params.page !== undefined) {
    query.set("page", String(params.page));
  }
  if (params.page_size !== undefined) {
    query.set("page_size", String(params.page_size));
  }
  if (params.star !== undefined) {
    query.set("star", String(params.star));
  }
  const value = query.toString();
  return value ? `?${value}` : "";
};

export const feedbackApi = {
  getProductFeedback: (productId: number, params?: FeedbackQuery) => {
    return apiClient.get(
      `/feedback/product/${productId}${buildFeedbackQuery(params)}`
    );
  },
  getProductFeedbackSummary: (productId: number) => {
    return apiClient.get(`/feedback/product/${productId}/summary`);
  },
  postProductFeedback: (payload: FeedbackCreate) => {
    return apiClient.post("/feedback/product", payload);
  },
};

export default feedbackApi;
